import { CoreLogService } from "../log.service";
import { Lifecycletrigger, LifecycletriggerDefault } from "./comEnvironmentTriggerLifecycletrigger";
import { Subject, BehaviorSubject } from "rxjs";

/** Loader */

export interface Loader {
  /** Sichtbarkeitsstatus des Loaders */
  visible: BehaviorSubject<boolean>;

  /** Fügt einen Loadertask hinzu. Der Loader wird solange angezeigt bis alle Tasks wieder entfernt wurden.
  * @param name Taskname
  */
  addTask(name: string);

  /** Entfernt einen Loadertask. Der Loader wird solange angezeigt bis alle Tasks wieder entfernt wurden.
 * @param name Taskname
 */
  removeTask(name: string);

  /** Zeigt an, ob dieser Task der Liste hinzugefügt wurde.
 * @param name Taskname
 */
  isTaskAdded(name: string);

  /** Entfernt alle Loadertask und blendet den Loader aus. */
  clear(): void;
}

/**
* Standardimplementierung
*/
export class LoaderDefault implements Loader {

  private _tasks: string[] = [];
  private _visible: BehaviorSubject<boolean>;

  /** Loader  */
  constructor(private _coreLogService: CoreLogService) {
    this.setVisible(new BehaviorSubject<boolean>(false));
  }

  public get visible(): BehaviorSubject<boolean> {
    return this._visible;
  }

  private setVisible(value: BehaviorSubject<boolean>) {
    this._visible = value;
  }

  /** Fügt einen Loadertask hinzu. Der Loader wird solange angezeigt bis alle Tasks wieder entfernt wurden.
   * @param name Taskname
   */
  public addTask(name: string) {
    if (this._tasks.indexOf(name) < 0) {
      this._tasks.push(name);
      if (!this.visible.getValue()) {
        this.visible.next(true);
      }
    }
  }

  /** Entfernt einen Loadertask. Der Loader wird solange angezeigt bis alle Tasks wieder entfernt wurden.
   * @param name Taskname
   */
  public removeTask(name: string) {
    if (this._tasks.indexOf(name) > -1) {
      this._tasks.splice(this._tasks.indexOf(name), 1);
      if (this.visible.getValue() && this._tasks.length == 0) {
        this.visible.next(false);
      }
    }
  }

  /** Zeigt an, ob dieser Task der Liste hinzugefügt wurde.
 * @param name Taskname
 */
  public isTaskAdded(name: string): boolean {
    return (this._tasks.indexOf(name) > -1);
  }

  /** Entfernt alle Loadertask und blendet den Loader aus. */
  public clear() {
    this._tasks = [];
    this.visible.next(false);
  }
}
